// Studio-Theme-Tokens — dicht, professionell, kein Serif/Italic.
// Basiert auf dem Traumbeauty "Studio"-Design aus dem Handoff.

export const T = {
  bg:        '#fafaf8',
  surface:   '#ffffff',
  surface2:  '#f4f4f0',
  paper:     '#eeede7',
  text:      '#181a1d',
  muted:     '#5f6772',
  faint:     '#a7adb6',
  accent:    '#b87b6a',
  accentSoft:'#f0d4c8',
  line:      'rgba(24,26,29,0.10)',
  lineSoft:  'rgba(24,26,29,0.06)',
  danger:    '#c54a3e',
  warn:      '#c98a3a',
  ok:        '#3e9468',
  info:      '#3a7ab8',
  display:   '"Outfit", -apple-system, system-ui, sans-serif',
  body:      '"Outfit", -apple-system, system-ui, sans-serif',
  mono:      '"JetBrains Mono", ui-monospace, monospace',
  r: { sm: 4, md: 6, lg: 10 },
} as const;

export type AdminTheme = typeof T;

export function rgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

// Alle möglichen Booking-Status (Frontend + Backend)
export type AnyStatus = string;

// Gibt Farben + Label für jeden Booking-Status zurück
export function mapStatus(s: AnyStatus): AnyStatus { return s; }

export function statusColors(status: AnyStatus): { fg: string; bg: string; label: string } {
  switch (status) {
    case 'confirmed':      return { fg: T.info,   bg: rgba(T.info,   0.12), label: 'Bestätigt' };
    case 'confirmed_paid': return { fg: T.ok,     bg: rgba(T.ok,     0.13), label: 'Bezahlt'   };
    case 'pending_payment':return { fg: T.warn,   bg: rgba(T.warn,   0.14), label: 'Zahlung offen' };
    case 'pending':        return { fg: T.warn,   bg: rgba(T.warn,   0.14), label: 'Offen'     };
    case 'completed':      return { fg: T.ok,     bg: rgba(T.ok,     0.13), label: 'Erledigt'  };
    case 'cancelled':      return { fg: T.faint,  bg: rgba(T.faint,  0.18), label: 'Storno'    };
    case 'no_show':        return { fg: T.danger, bg: rgba(T.danger, 0.13), label: 'No-Show'   };
    case 'noshow':         return { fg: T.danger, bg: rgba(T.danger, 0.13), label: 'No-Show'   };
    default:               return { fg: T.muted,  bg: rgba(T.muted,  0.12), label: status      };
  }
}

// Wochenstart (Montag) für ein Datum berechnen
export function getWeekStart(d: Date): Date {
  const day = d.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  const m = new Date(d);
  m.setDate(d.getDate() + diff);
  m.setHours(0, 0, 0, 0);
  return m;
}

export function toIso(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export const WEEK_DAYS_SHORT = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
export const MONTH_NAMES = [
  'Januar','Februar','März','April','Mai','Juni',
  'Juli','August','September','Oktober','November','Dezember',
];
